<template>
  <!-- 底部 -->
  <div>
    <div class="footer">
      <el-row>
        <!-- 第一列 -->
        <el-col :span="10">
          <div class="text" style="text-indent: 0rem ;color:rgb(179,170,170)">
            <p>Copyright © 2023, National Astronomical Observatories, Chinese Academy of Sciences
              Addr: 20A Datun Road, Chaoyang District, Beijing, China P.C.:
              100101 <a href="https://beian.miit.gov.cn/" style="text-decoration: none;">京ICP备05002854号-4</a>
              文保网安备案号1101050056 E-mail: support(at)china-vo.org</p>
          </div>
        </el-col>
        <!-- 第二列 -->
        <el-col :span="4" :offset="3">
          <div style="padding-top:35px"><a href="http://www.china-vo.org/"><img src="../assets/logo1.png" alt=""></a>
          </div>
        </el-col>
        <!-- 第三列 -->
        <el-col :span="3">
          <div style="padding-top:25px"><a href="https://nadc.china-vo.org/"><img src="../assets/logo2.png" alt=""></a>
          </div>
        </el-col>
        <!-- 第四列 -->
        <el-col :span="4">
          <div style="padding-top:25px"><a href="https://www.escience.org.cn/"><img src="../assets/logo3.png" alt=""></a>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 100%;
  font-size: 0.8rem;
  text-align: center;
  background-color: rgb(38, 38, 38);
  line-height: 25px;

  p {
    padding-left: 20px;
    text-align: justify;
  }

  img {
    width: 60%;
    height: 50%;
    background-size: 100%;
  }

  .text {
    a {
      color: rgb(161, 162, 165);
    }

    a:hover {
      color: gray;
    }
  }
}
</style>